import styled from 'styled-components';
import { CardSubtitle, CardBody } from 'reactstrap';
import { spacer, multiply, mediaBreakpointUp, gray, fontFamily, fontStyle } from '@whitelabel/helpers/style';

export const StyledBookingCard = styled.article`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: ${spacer};

  ${mediaBreakpointUp('md')`
    flex-direction: row;
    margin-bottom: ${multiply(spacer, 1.5)};
  `}

  ${mediaBreakpointUp('lg')`
    margin-bottom: ${multiply(spacer, 2)};
  `}

  &:last-child {
    margin-bottom: 0;
  }
`;

export const StyledBookingContent = styled.div`
  flex-grow: 1;
  width: 100%;
`;

export const StyledCardSubtitle = styled(CardSubtitle).attrs(() => ({ tag: 'p' }))`
  ${fontStyle('subtext')};
  grid-area: subtitle;
  margin: 0;
  overflow: hidden;
  color: ${gray(600)};
  font-family: ${fontFamily('serif')};
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const StyledCardBody = styled(CardBody)`
  display: grid;
  grid-template-columns: 1fr auto;

  ${mediaBreakpointUp('lg')`
    padding: ${spacer};
  `}
`;

export const StyledAttributes = styled.dl`
  display: flex;
  grid-row: 2;
  grid-column: 1;
  margin-top: ${multiply(spacer, 0.5)};
  margin-bottom: 0;

  ${mediaBreakpointUp('md')`
    grid-column: 1 / 3;
    margin-top: ${spacer};
  `}

  ${mediaBreakpointUp('lg')`
    grid-column: 1;
  `}
`;
